import React, { useEffect, useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { Assignment, Cancel, CheckCircle, Save } from '@material-ui/icons';
import moment from 'moment';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Button from 'components/CustomButtons/Button';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import styles from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js';
import GridContainer from 'components/Grid/GridContainer';
import { wsFindBy } from 'services/WService';
import {
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  TextField,
  Checkbox,
  FormControlLabel
} from '@material-ui/core';

// react component used to create sweet alerts
import SweetAlert from 'react-bootstrap-sweetalert';
import stylesSweealert from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';

import { WithApp } from 'contexts/appContext';
import { onlyInteger } from 'hooks/Pipe';

import { wsRemove, wsCreate, wsUpdate } from 'services/WService';

const useStyles = makeStyles({
  ...styles,
  ...stylesSweealert,
  marginRight: {
    float: 'right',
    margin: 'auto'
  },
  title: {
    marginTop: '15px',
    fontSize: '20px',
    color: '#3C4858'
  }
});

const evaluationTypes = [
  { value: 'P', text: 'Producto' },
  // { value: 'S', text: 'Proveedor' },
  // { value: 'C', text: 'Categoria' },
  // { value: 'F', text: 'Familia' }
];

// const bonificationTypes = [
//   { value: 'P', text: 'Producto' },
//   { value: 'D', text: 'Descuento %' },
//   { value: 'S', text: 'Descuento S/' }
// ];

const promoStates = [
  { value: 'P', text: 'Aprobado' },
  { value: 'V', text: 'Vigente' },
  { value: 'L', text: 'Liquidado' },
  { value: 'I', text: 'Inactivo' },
  { value: 'G', text: 'Generado' },
  { value: 'N', text: 'Nuevo' },
  { value: 'C', text: 'Cancelado' }
];

export default WithApp(function General(props) {
  const classes = useStyles();
  const [alert, setAlert] = useState(null);
  const form = useRef(null);

  const { showNotify, reload, existSaleGroup, existBoniGroup, promotionInitial, isNew } = props;

  const [businessPartners, setBusinessPartners] = useState([]);

  const [promotion, setPromotion] = useState({});

  const state = promotionInitial.state == 'N' || promotionInitial.state == 'G' ? false : true;

  async function listBusinessPartner() {
    let response = await wsFindBy('base/business-partner', { CardType: 'S', QryGroup1: 'Y' });
    if (response.success) {
      setBusinessPartners(response.data);
    }
  }

  const getValuesInput = (ref) => {
    let dataForm = {};
    for (let input of ref.current.querySelectorAll('[name]')) {
      dataForm[input.name] = input.value;
    }
    return dataForm;
  };

  const handleChange = (e) => {
    setPromotion({ ...promotion, [e.target.name]: e.target.value });
  };

  async function saveUpdate(data) {
    if (!!promotion.id) {
      if (!data.customer_limit) {
        delete data.limit_per_customer;
      }
      let newData = {};
      for (let key in data) {
        if (promotionInitial[key] != data[key]) {
          newData[key] = data[key];
        }
      }
      if (Object.keys(newData).length < 1) {
        return;
      }
      if (newData?.parent_promotion_id === '') {
        newData.parent_promotion_id = null;
      }

      if (promotion.state !== 'N' && promotion.state !== 'G') {
        if (promotion.only_business_lines === 'Y' && promotion.lines.length === 0) {
          showNotify('Ingrese 1 a más giros de negocio o retire la opción marcada', 'info');
          return;
        }
      }

      let response = await wsUpdate('prom/promotion', promotion.id, newData);
      if (response.success) {
        showNotify(response.message);
        reload();
      } else {
        showNotify(response.message, 'error');
      }
    } else {
      createPromotion(promotion);
    }
  }

  async function createPromotion(data) {
    let dataForm = getValuesInput(form);
    Object.assign(dataForm, data);

    // Data límite cliente
    if (!dataForm.customer_limit) {
      delete dataForm.customer_limit;
      delete dataForm.limit_per_customer;
      delete dataForm.limit_customer_type;
    }
    let response = await wsCreate('prom/promotion', dataForm);
    if (response.success) {
      showNotify(response.message);
      window.location.replace(`/admin/articulos/operaciones/combos/${response.data.id}`);
    } else {
      showNotify(response.message, 'error');
    }
  }

  /* function confirmDeleteGroups(idProvider) {
    setAlert(
      <SweetAlert
        allowEscape={false}
        closeOnClickOutside={false}
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title="Los grupos serán eliminados"
        onConfirm={() => {
          saveUpdate({ base_business_partner_id: idProvider });
          deleteGroups();
          setAlert(null);
        }}
        onCancel={() => setAlert(null)}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      >
        ¡Si cambia de proveedor todos los grupos de esta promoción serán eliminados!
      </SweetAlert>
    );
  } */

  function confirmAction(info) {
    setAlert(
      <SweetAlert
        allowEscape={false}
        closeOnClickOutside={false}
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title={info.title}
        onConfirm={() => {
          if (info.deleteGroups) {
            saveUpdate(info.data);
            deleteGroups();
          }
          setAlert(null);
        }}
        onCancel={() => {
          setAlert(null);
          let bp = promotion.base_business_partner_id;
          setPromotion((promotion) => ({
            ...promotion,
            base_business_partner_id: -1,
          }));
          setTimeout(() => {
            setPromotion((promotion) => ({
              ...promotion,
              base_business_partner_id: bp,
            }));
          }, 100);
        }}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      >
        {info.description}
      </SweetAlert>
    );
  }

  /* function confirmDeleteGroups2(idEvaluation) {
    setAlert(
      <SweetAlert
        allowEscape={false}
        closeOnClickOutside={false}
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title="Los grupos serán eliminados"
        onConfirm={() => {
          saveUpdate({ evaluation_type: idEvaluation });
          deleteGroups();
          setAlert(null);
        }}
        onCancel={() => setAlert(null)}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      >
        ¡Si cambia de evaluación todos los grupos de esta promoción serán eliminados!
      </SweetAlert>
    );
  } */

  async function deleteGroups() {
    let [saleResponse, boniResponse] = await Promise.all([
      wsRemove('prom/promotion/' + promotionInitial.id + '/sell-groups'),
      wsRemove('prom/promotion/' + promotionInitial.id + '/bonification-groups')
    ]);
    if (saleResponse.success || boniResponse.success) {
      showNotify('Grupos eliminados');
      window.location.reload();
    } else {
      showNotify('Error al eliminar grupos', 'error');
    }
  }

  useEffect(() => {
    setPromotion(promotionInitial);
  }, [promotionInitial]);

  useEffect(() => {
    listBusinessPartner();
  }, []);

  return (
    <GridItem xs={12}>
      <h4>
        <b> Número de promoción: {promotion.id}</b>
      </h4>
      {alert}
      <Card>
        <form
          ref={form}
          onSubmit={(e) => {
            e.preventDefault();
            saveUpdate(promotion);
          }}
        >
          <CardHeader icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <div className={classes.title}>
              <span>General</span>
              <Button
                type="submit"
                justIcon
                round
                color={props.themeContext.buttonColorSuccess}
                className={classes.marginRight}
              >
                <Save />
              </Button>
            </div>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} xl={4}>
                <GridContainer>
                  <GridItem xl={12} lg={4} md={6} xs={12}>
                    <Autocomplete
                      disableClearable
                      key={promotion.base_business_partner_id}
                      options={businessPartners}
                      getOptionLabel={(item) => item.CardName}
                      renderInput={(params) => (
                        <TextField {...params} label="Proveedor" margin="normal" required />
                      )}
                      value={
                        businessPartners.find(
                          (bp) => bp.id == promotion.base_business_partner_id,
                        ) || null
                      }
                      onChange={(e, bp) => {
                        if (existSaleGroup || existBoniGroup) {
                          confirmAction({
                            data: { base_business_partner_id: bp.id },
                            title: 'Todos los grupos serán eliminados',
                            description:
                              '¡Si cambia de proveedor todos los grupos de esta promoción serán eliminados!',
                            deleteGroups: true,
                          });
                          return;
                        }
                        setPromotion((promotion) => ({
                          ...promotion,
                          base_business_partner_id: bp.id,
                        }));
                      }}
                    />
                  </GridItem>
                  <GridItem xl={12} lg={8} md={6} xs={12}>
                    <TextField
                      label="Descripción"
                      fullWidth
                      name="description"
                      margin="normal"
                      size="small"
                      value={promotion.description || ''}
                      multiline
                      onChange={handleChange}
                      inputProps={{
                        minRows: window.screen.width <= 1880 ? 1 : 5,
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled={state}
                      required={!promotion.id}
                    />
                  </GridItem>
                </GridContainer>
              </GridItem>
              <GridItem xl={4} lg={6} xs={12}>
                <GridContainer>
                  <GridItem sm={6} xs={12}>
                    <FormControl fullWidth margin="normal" disabled={state}>
                      <InputLabel shrink>Tipo de Bonificación</InputLabel>
                      <Select
                        value={promotion.bonification_type || ''}
                        inputProps={{
                          name: 'bonification_type',
                          onChange: handleChange,
                        }}
                      >
                        <MenuItem value="C">Combo</MenuItem>
                      </Select>
                    </FormControl>
                  </GridItem>
                  <GridItem sm={6} xs={12}>
                    <FormControl fullWidth margin="normal" disabled={state}>
                      <InputLabel shrink>Tipo de Evaluación</InputLabel>
                      <Select
                        value={promotion.evaluation_type || ''}
                        inputProps={{
                          name: 'evaluation_type',
                          onChange: existSaleGroup || existBoniGroup ? null : handleChange,
                        }}
                      >
                        {evaluationTypes.map((evaluationT, i) => {
                          return (
                            <MenuItem
                              value={evaluationT.value}
                              key={i}
                              onClick={() => {
                                if (existSaleGroup || existBoniGroup) {
                                  confirmAction({
                                    data: { evaluation_type: evaluationT.value },
                                    title: 'Todos los grupos serán eliminados',
                                    description:
                                      '¡Si cambia de evaluación todos los grupos de esta promoción serán eliminados!',
                                    deleteGroups: true,
                                  });
                                }
                              }}
                            >
                              {evaluationT.text}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem sm={6} xs={12}>
                    <FormControl fullWidth margin="normal">
                      <InputLabel shrink>Estado</InputLabel>
                      <Select
                        inputProps={{
                          name: 'state',
                          onChange: handleChange,
                        }}
                        value={promotion.state || ''}
                      >
                        {promoStates
                          .filter((item) =>
                            isNew ? item.value === 'N' || item.value === 'G' : item,
                          )
                          .map((item, i) => (
                            <MenuItem key={i} value={item.value}>
                              {item.text}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </GridItem>
                  <GridItem sm={6} xs={12}>
                    <FormControl fullWidth>
                      <TextField
                        label="Cod. Externo"
                        name="external_code"
                        value={promotion.external_code || ''}
                        margin="normal"
                        onChange={handleChange}
                        disabled={state}
                      />
                    </FormControl>
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem sm={6} xs={12}>
                    <TextField
                      label="Fecha inicio"
                      type="date"
                      name="start_date"
                      onChange={handleChange}
                      fullWidth
                      margin="normal"
                      size="small"
                      value={promotion.start_date || moment().format('YYYY-MM-DD')}
                      className={classes.textField}
                      disabled={state}
                      required={!promotion.id}
                    />
                  </GridItem>
                  <GridItem sm={6} xs={12}>
                    <TextField
                      label="Fecha fin"
                      type="date"
                      name="end_date"
                      onChange={handleChange}
                      size="small"
                      fullWidth
                      margin="normal"
                      value={promotion.end_date || moment().endOf('month').format('YYYY-MM-DD')}
                      className={classes.textField}
                      disabled={state}
                      required={!promotion.id}
                    />
                  </GridItem>
                </GridContainer>
              </GridItem>
              <GridItem xl={4} lg={6} xs={12}>
                <GridContainer>
                  <GridItem sm={4} xs={12}>
                    <TextField
                      label="Lím. Promoción"
                      type="number"
                      margin="normal"
                      name="limit_promotion"
                      fullWidth
                      onChange={handleChange}
                      value={promotion.limit_promotion || 0}
                      inputProps={{ min: 0 }}
                      disabled={state}
                    />
                  </GridItem>
                  <GridItem sm={4} xs={12}>
                    <TextField
                      label="Límite Monto"
                      fullWidth
                      type="number"
                      margin="normal"
                      name="limit_amount"
                      onChange={handleChange}
                      value={promotion.limit_amount || 0}
                      inputProps={{ min: 0 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled={state}
                    />
                  </GridItem>
                  <GridItem sm={4} xs={12}>
                    <TextField
                      label="Límite Umes"
                      type="number"
                      margin="normal"
                      name="limit_ume"
                      fullWidth
                      onChange={handleChange}
                      value={promotion.limit_ume || 0}
                      inputProps={{ min: 0 }}
                      disabled={state}
                    />
                  </GridItem>
                </GridContainer>
                {/* Avances */}
                <GridContainer>
                  <GridItem xs={12} sm={4} md={4}>
                    <TextField
                      label="Avc. Promoción"
                      type="number"
                      name="advance_promotion"
                      fullWidth
                      onChange={handleChange}
                      value={promotion.advance_promotion || 0}
                      margin="normal"
                      disabled
                    />
                  </GridItem>
                  <GridItem xs={12} sm={4} md={4}>
                    <TextField
                      label="Avance Monto"
                      type="number"
                      name="advence_amount"
                      fullWidth
                      onChange={handleChange}
                      value={promotion.advence_amount || 0}
                      disabled
                      margin="normal"
                    />
                  </GridItem>
                  <GridItem xs={12} sm={4} md={4}>
                    <TextField
                      label="Avance Umes"
                      type="number"
                      name="advance_ume"
                      fullWidth
                      onChange={handleChange}
                      value={promotion.advance_ume || 0}
                      disabled
                      margin="normal"
                    />
                  </GridItem>
                </GridContainer>

                {/* Limitación de clientes */}
                <GridContainer>
                  <GridItem xs={12} sm={6} style={{ display: 'flex', alignItems: 'flex-end' }}>
                    <TextField
                      fullWidth
                      name="limit_per_customer"
                      label="Límite cliente"
                      type="number"
                      value={promotion.limit_per_customer || ''}
                      onChange={handleChange}
                      margin="normal"
                      disabled={state || !promotion.customer_limit}
                      required={promotion.customer_limit}
                      inputProps={{ min: 0, max: 1000 }}
                      onKeyPress={onlyInteger}
                      InputProps={{
                        startAdornment: (
                          <Checkbox
                            style={{ height: 0 }}
                            name="customer_limit"
                            margin="normal"
                            checked={!!promotion.customer_limit || false}
                            disabled={state}
                            onChange={() =>
                              setPromotion({
                                ...promotion,
                                customer_limit: !promotion.customer_limit,
                              })
                            }
                          />
                        ),
                      }}
                    />

                    {/* < asd */}
                    <FormControl
                      fullWidth
                      margin="normal"
                      disabled={state || !promotion.customer_limit}
                      required={promotion.customer_limit}
                    >
                      <InputLabel shrink>Tipo Límite cliente</InputLabel>
                      <Select
                        MenuProps={{
                          className: classes.selectMenu,
                        }}
                        value={promotion.limit_customer_type || ''}
                        inputProps={{
                          name: 'limit_customer_type',
                          onChange: handleChange,
                        }}
                      >
                        <MenuItem value="D">Día</MenuItem>
                        <MenuItem value="M">Mes</MenuItem>
                      </Select>
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={6}>
                    <TextField
                      disabled={state || promotion.new_customer_date === null}
                      fullWidth
                      type="date"
                      margin="normal"
                      className={classes.margin}
                      label="Solo clientes nuevos"
                      value={promotion.new_customer_date || ''}
                      onChange={(e) =>
                        setPromotion({ ...promotion, new_customer_date: e.target.value })
                      }
                      inputProps={{ max: moment().format('YYYY-MM-DD') }}
                      InputProps={{
                        startAdornment: (
                          <Checkbox
                            style={{ height: 0 }}
                            checked={promotion.new_customer_date ? true : false}
                            disabled={state}
                            onChange={(e) => {
                              const check = e.target.checked;
                              setPromotion({
                                ...promotion,
                                new_customer_date: check ? moment().format('YYYY-MM-DD') : null,
                              });
                            }}
                          />
                        ),
                      }}
                    />
                  </GridItem>
                </GridContainer>
              </GridItem>
            </GridContainer>
            {/* Estados */}
            <GridContainer>
              <GridItem xs={12} sm={2} md={2}>
                <FormControl fullWidth margin="normal" disabled={state}>
                  <InputLabel shrink>Condición Venta</InputLabel>
                  <Select
                    value={promotion.sale_condition || 'A'}
                    inputProps={{
                      name: 'sale_condition',
                      onChange: handleChange,
                    }}
                  >
                    <MenuItem value="C">Contado</MenuItem>
                    <MenuItem value="R">Crédito</MenuItem>
                    <MenuItem value="A">Ambos</MenuItem>
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem xs={12} sm={2} md={2}>
                <FormControl fullWidth margin="normal" disabled={state}>
                  <InputLabel shrink>Origen</InputLabel>
                  <Select
                    value={promotion.origin || ''}
                    inputProps={{
                      name: 'origin',
                      onChange: handleChange,
                    }}
                  >
                    <MenuItem value="E">Externo</MenuItem>
                    <MenuItem value="I">Interno</MenuItem>
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem xs={12} sm={4} md={2}>
                <FormControl fullWidth margin="normal" disabled={state}>
                  <InputLabel shrink>Condición</InputLabel>
                  <Select
                    value={promotion.condition || ''}
                    inputProps={{
                      name: 'condition',
                      onChange: handleChange,
                    }}
                  >
                    <MenuItem value="Q">Cantidad</MenuItem>
                    <MenuItem value="M">Monto</MenuItem>
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem xs={12} sm={4} md={2}>
                <TextField
                  name="parent_promotion_id"
                  label="Promoción padre"
                  type="text"
                  fullWidth
                  value={promotion.parent_promotion_id || ''}
                  onChange={handleChange}
                  onKeyPress={onlyInteger}
                  margin="normal"
                  disabled={state}
                />
              </GridItem>

              <GridItem xs={12} sm={4} md={2} style={{ display: 'flex', alignItems: 'flex-end' }}>
                <FormControlLabel
                  label="Sólo giros de negocio"
                  control={
                    <Checkbox
                      margin="normal"
                      checked={promotion.only_business_lines === 'Y' ? true : false}
                      disabled={state}
                      onChange={(e) =>
                        setPromotion({
                          ...promotion,
                          only_business_lines: e.target.checked ? 'Y' : 'N',
                        })
                      }
                    />
                  }
                />
              </GridItem>
              <GridItem xs={12} sm={4} md={2} style={{ display: 'flex', alignItems: 'flex-end' }}>
                <FormControlLabel
                  label="Evaluar UM"
                  control={
                    <Checkbox
                      margin="normal"
                      checked={promotion.evaluate_um || false}
                      disabled={state}
                      onChange={(e) =>
                        setPromotion({
                          ...promotion,
                          evaluate_um: e.target.checked,
                        })
                      }
                    />
                  }
                />
              </GridItem>
              <GridItem xs={12} sm={4} md={2} style={{ display: 'flex', alignItems: 'flex-end' }}>
                <FormControlLabel
                  label="Plan sorpresa"
                  control={
                    <Checkbox
                      margin="normal"
                      checked={promotion.surprise_plan || false}
                      disabled={state}
                      onChange={(e) =>
                        setPromotion({
                          ...promotion,
                          surprise_plan: e.target.checked,
                        })
                      }
                    />
                  }
                />
              </GridItem>
            </GridContainer>
          </CardBody>
        </form>
      </Card>
    </GridItem>
  );
});
